import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import TextInput from '../TextInput';

const TextFieldComp = ({
  // Custom props
  id, disabled, fullWidth, hideRequiredText, hideTooltip, inputProps, maxLength, multiline, placeholder,
  required, rows, rowsMax, type, readOnly, style, highlightMissing,
  // Redux Form props
  input, meta,
}) => {
  const intl = useIntl();
  let error = '';
  if (meta.error) {
    const { message, ...rest } = meta.error;
    error = intl.formatMessage({ id: message }, { ...rest });
  }

  return (
    <TextInput
        // Redux Form Props
      name={input.name}
      onChange={input.onChange}
      onFocus={input.onFocus}
      onBlur={input.onBlur}
      onDragStart={input.onDragStart}
      onDrop={input.onDrop}
      value={input.value}
      error={error}
        // Custom props
      id={id}
      disabled={disabled}
      errorPlacement="right"
      fullWidth={fullWidth}
      hideRequiredText={hideRequiredText}
      hideTooltip={hideTooltip}
      inputProps={inputProps}
      maxLength={maxLength}
      maxRows={rowsMax}
      multiline={multiline}
      placeholder={placeholder}
      readOnly={readOnly}
      required={required}
      rows={rows}
      style={style}
      type={type}
      highlightMissing={highlightMissing}
    />
  );
};

TextFieldComp.propTypes = {
  // Custom props
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  hideRequiredText: PropTypes.bool,
  hideTooltip: PropTypes.bool,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  maxLength: PropTypes.number,
  multiline: PropTypes.bool,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  rows: PropTypes.number,
  rowsMax: PropTypes.number,
  type: PropTypes.string,
  style: PropTypes.object,
  // Redux Form props
  input: PropTypes.object,
  meta: PropTypes.object,
  inputStyle: PropTypes.object,
  highlightMissing: PropTypes.bool,
};

export default TextFieldComp;
